// extracted by mini-css-extract-plugin
export default {"wrapper":"G3-z","play":"H3-z"};